import { useEffect, useState } from 'react'

import PropTypes from 'prop-types'
import { Prompt } from 'react-router-dom'
import { styled } from 'styled-components'

import useDraft from 'contexts/DraftContext/useDraft'

import { Modal } from 'core/components/legacy'
import { InfoCard } from 'core/components/lib/InfoCard'
import SubmitSection from 'core/components/lib/SubmitSection'

const Message = styled.div`
  padding: 0 24px;
`

const RouteLeaveGuard = ({ when, navigate }) => {
  const [showModal, setShowModal] = useState(false)
  const [lastLocation, setLastLocation] = useState(null)
  const [confirmedNavigation, setConfirmedNavigation] = useState(false)
  const { clearDrafts, alert } = useDraft()

  const handleBlockedNavigation = (nextLocation) => {
    if (!confirmedNavigation) {
      setShowModal(true)
      setLastLocation(nextLocation)
      return false
    }
    return true
  }
  const handleConfirmNavigationClick = () => {
    setShowModal(false)
    setConfirmedNavigation(true)
    clearDrafts()
  }
  useEffect(() => {
    if (confirmedNavigation && lastLocation) {
      // Navigate to the previous blocked location with your navigate function
      navigate(lastLocation.pathname)
      setConfirmedNavigation(false)
      setLastLocation(null)
    }
  }, [confirmedNavigation, lastLocation, navigate])

  return (
    <>
      <Prompt message={handleBlockedNavigation} when={when} />
      {showModal && (
        <Modal onClose={() => setShowModal(false)} width={560}>
          <InfoCard key='route-leave-guard' title={alert.title}>
            <Message>{alert.message}</Message>
            <SubmitSection
              cancelText='Cancel'
              onCancel={() => setShowModal(false)}
              onSubmitPrimary={handleConfirmNavigationClick}
              submitPrimaryText='Confirm'
            />
          </InfoCard>
        </Modal>
      )}
    </>
  )
}

RouteLeaveGuard.propTypes = {
  when: PropTypes.bool,
  navigate: PropTypes.func,
}

export default RouteLeaveGuard
